import { deleteFilter as deleteFilterDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type Props = ApiMethodBase & {
    type?: string
}

const sleep = ms => new Promise(r => setTimeout(r, ms));


export  async function deleteFilter ({type,eventEmitter}) {

    await deleteFilterDiagram();
    if (type === 'filter') eventEmitter.emit(Event.resetFilter);
    if (type === 'discovery') eventEmitter.emit(Event.resetDiscovery);

    if (apiProvider.getActiveAction() === 'process_miner') apiProvider.setDiagramVisualizer()    
    if (apiProvider.getActiveAction() === 'time_in_activity') eventEmitter.emit(Event.updateTimeInActivity);
    if (apiProvider.getActiveAction() === 'decomposition_tree') {
        apiProvider.setAction_DecompositionTree({})
        apiProvider.setDiagramDecompositionTree({source: 'applyTimeFilter'})
    }
    if (apiProvider.getActiveAction() === 'cluster_insights') {
        apiProvider.setAction_Cluster({})
        apiProvider.setDiagramCluster({source: 'applyTimeFilter'})
    }
    if (apiProvider.getActiveAction() === 'influence_analysis') {
        apiProvider.setAction_InfluenceAnalysis({})
        apiProvider.setDiagramInfluenceAnalysis({source: 'applyTimeFilter'})
    }   
    eventEmitter.emit(Event.updateGaugeMetrics);
    await sleep(50) // needed to display Progress
    if (type === 'filter') eventEmitter.emit(Event.resetFilter);
    if (type === 'discovery') eventEmitter.emit(Event.resetDiscovery);


};
